import React from "react";
import { Card } from "react-bootstrap";

/**
 * @typedef {Object} ChartCardProps
 * @property {string} title
 * @property {string} [subtitle]
 * @property {string} [action]
 * * @property {import('react').ReactNode} children
 */

/**
 * @param {ChartCardProps} props
 */
export function ChartCard({ title, subtitle, children, action }) {
  return (
    <Card className="pbi-chart-card h-100">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <div className="pbi-chart-title">{title}</div>
            {subtitle && <div className="pbi-chart-subtitle">{subtitle}</div>}
          </div>
          {action}
        </div>
        <div className="pbi-chart-body">{children}</div>
      </Card.Body>
    </Card>
  );
}
